import logo from "assets/icons/shopwerk.svg";
import { useCallback, useEffect } from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootReduxState } from "../../../../../utils/types";
import { ConnectedIntegrationLineWrapper } from "../../components/ConnectedIntegrationLineWrapper";
import {
  ShopwerkDataReduxState,
  ShopwerkRequestReduxState,
  deleteShopwerkIntegrationAction,
  getShopwerkIntegrationSettingsAction,
  resetShopwerkIntegrationsRequestsAction
} from "./redux";

const mapStateToProps = (state: RootReduxState) => {
  const shopId = state.getIn(["customerBackendDashboard", "userData", "selectedShopId"]) as string;

  const deleteRequestState = state
    .getIn(["integrations", "shopwerk", "requests", "delete"])
    .toJS() as ShopwerkRequestReduxState;

  return {
    shopId: Number(shopId),
    deleteRequestState,
    integrationData: state.getIn(["integrations", "shopwerk", "data"])?.toJS() as
      | ShopwerkDataReduxState
      | undefined
  };
};

const matchDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getShopwerkIntegrationSettingsAction,
      deleteShopwerkIntegrationAction,
      resetShopwerkIntegrationsRequestsAction
    },
    dispatch
  );
const connector = connect(mapStateToProps, matchDispatchToProps);

type ShopwerkSettingsViewComponentProps = ConnectedProps<typeof connector>;

const ShopwerkSettingsViewComponent = (
  props: ShopwerkSettingsViewComponentProps & WrappedComponentProps
) => {
  const {
    integrationData,
    deleteRequestState,
    deleteShopwerkIntegrationAction,
    resetShopwerkIntegrationsRequestsAction,
    shopId
  } = props;

  useEffect(
    () => () => {
      resetShopwerkIntegrationsRequestsAction();
    },
    []
  );

  const handleDelete = useCallback(() => {
    deleteShopwerkIntegrationAction(shopId);
  }, [shopId]);

  if (integrationData === undefined || integrationData.settings === undefined) {
    return null;
  }

  return (
    <ConnectedIntegrationLineWrapper
      accountName={"Uptain GmbH"}
      deleting={deleteRequestState.loading}
      image={logo}
      name="Shopwerk"
      onDelete={handleDelete}
      noOpen
    />
  );
};

export const ShopwerkSettingsView = connector(injectIntl(ShopwerkSettingsViewComponent));
